import gql from 'graphql-tag'
import { GQL_USER_DEFAULT_FIELDS } from '@/components/users/graphql/graphql.const.ts'

export const ReleaseUserMutation = gql`
    mutation ReleaseUser($userId: Uint!) {
      user: releaseUser (userId: $userId) {
        ${GQL_USER_DEFAULT_FIELDS}
      }
    }
  `
export const RestrictUserMutation = gql`
    mutation RestrictUser($userId: Uint!) {
      user: restrictUser (userId: $userId) {
        ${GQL_USER_DEFAULT_FIELDS}
      }
    }
  `

export const CreateOrUpdateUserMutation = gql`
  mutation CreateOrUpdateUser ($input: CreateOrUpdateUserInput!) {
    user: createOrUpdateUser (input: $input) {
      ${GQL_USER_DEFAULT_FIELDS}
    }
  }`

export const AuthorizeUserMutation = gql`
  mutation AuthorizeUser($input: AuthorizeUserInput!) {
    user: authorizeUser (input: $input) {
      id
      roleId
      username
      firstname
      lastname
    }
  }
`

export const UnAuthorizeUserMutation = gql`
  mutation UnAuthorizeUser {
    user: unauthorizeUser {
      succeed
    }
  }
`
